import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUserPageAuth } from '../../../utils/page-auth';
import Notification from '../../../components/Notification/Notification';
import {
  settlementListApprovalRequest,
  walletSettlementListRequest
} from '../../../redux/actions/wallet/settlementActions';
import { DEFAULT_END_AT } from '../../LogManagement/constants';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import BtnIcons from '../../../api/images/btnIcons';
import timeFormAPI from '../../../api/ui/timeFormAPI';
import btnIcons from '../../../api/images/btnIcons';

function needSettlement() {
  // -- component const --//
  const tHeadTotal = [
    '토큰',
    '소각할 토큰',
    '마켓 수수료',
    'NFT 거래 로열티',
    '월렛 계좌 전송 수수료',
    '월렛 NFT 전송 수수료',
    '상점 판매 액',
  ];

  const tHeadSelectable = [
    '선택',
    '정산 번호',
    '날짜',
    '토큰',
    '소각할 토큰',
    '마켓 수수료',
    'NFT 거래 로열티',
    '월렛 계좌 전송 수수료',
    '월렛 NFT 전송 수수료',
    '상점 판매 액',
  ];

  const tokens = ['XPER', 'PER', 'ARB'];

  const settlementDataKeys = [
    'settlementId',
    'date',
    ...tokens,
    'BurningFee',
    'MarketFee',
    'MarketRoyaltyFee',
    'TransactionFee',
    'NftTransactionFee',
    'ProductFee',
  ];

  const modalItems = [
    { key: 'current', label: '정산 전 잔고' },
    { key: 'fee', label: '수수료 정산 금액' },
    { key: 'burning', label: '소각 할 금액' },
    { key: 'settlement', label: '정산 합계(소각+수수료)' },
    { key: 'afterSettlement', label: '정산 후 예상 잔고' },
    { key: 'minimumRequirementToTransfer', label: '부족한 금액' },
    { key: 'nonTransferable', label: '앱 운영에 필요한 최소 잔고' },
    { key: 'available', label: '정산 가능 금액' }
  ];

  // -- useSelector & dispatch --//
  const dispatch = useDispatch();

  const user = useSelector((state) => state.authReducer.user);

  // -- state --//
  const [readOnly, setReadOnly] = useState(true);

  // 합계 테이블 데이터
  const [tBodyTotal, setTbodyTotal] = useState();
  // 전체 settlementIds
  const [totalList, setTotalList] = useState();
  // 정산이 필요한 내역 개수
  const [totalCount, setTotalCount] = useState(0);
  // 정산이 필요한 내역 테이블 데이터
  const [tBodySelectable, setTbodySelectable] = useState();
  // 선택된 날짜 settlementIds
  const [selectedSettlementIds, setSelectedSettlementIds] = useState([]);

  const [requiredTransaction, setRequiredTransaction] = useState([]);

  // 경고처리
  const isMinimumRequirementNotMet = Object.values(requiredTransaction?.minimumRequirementToTransfer || {}).some(value => value !== 0);

  const [notificationMessage, setNotificationMessage] = useState('');
  const [showNotification, setShowNotification] = useState(false);

  // 로딩
  const [isLoadingTotal, setIsLoadingTotal] = useState(false);
  const [isLoadingSelectable, setIsLoadingSelectable] = useState(false);
  // 이중 클릭 방지
  const [isLoadingRequesting, setIsLoadingRequesting] = useState(false);

  // 일괄인지 선택인지 타입 선택
  const [selectedType, setSelectedType] = useState('');

  // 모달
  const [openModal, setOpen] = useState(false);
  const [openModalApprovaled, setOpenApprovaled] = useState(false);

  // -- func & handler --//
  const fetchList = () => {
    setIsLoadingTotal(true);
    setIsLoadingSelectable(true);

    dispatch(walletSettlementListRequest({
      transactionStatus: 0, // // 정산 전 데이터 요청
      settlementType: 0,
      from: DEFAULT_END_AT,
      to: DEFAULT_END_AT,
      settlementIds: [],
      callback: (data) => {
        console.log('요청 결과: ', data);
        setTbodyTotal(data?.totalSettlements);
        setTbodySelectable(data?.list);
        setTotalCount(data?.list.length);
        setTotalList(data?.settlementIds);

        setIsLoadingTotal(false);
        setIsLoadingSelectable(false);
      },
      error: (e) => {
        console.log(e);
        setNotificationMessage(e.toString());
        setShowNotification(true);

        setIsLoadingTotal(false);
        setIsLoadingSelectable(false);
      },
    }));
  }

  const handleCheckboxChange = (settlementId) => {
    if (selectedSettlementIds.includes(settlementId)) {
      setSelectedSettlementIds(selectedSettlementIds.filter((id) => id !== settlementId));
    } else {
      setSelectedSettlementIds([...selectedSettlementIds, settlementId]);
    }
  };

  const approvalData = () => {
    setSelectedType('selected');

    dispatch(settlementListApprovalRequest({
      issuer: '', // ''로 무시
      dryRun: true, // 미리보기
      settlementIds: selectedSettlementIds,
      callback: (data) => {
        console.log('요청 결과: ', data);
        setOpen(true);
        setRequiredTransaction(data?.requiredTransaction);
      },
      error: (e) => {
        console.log(e);
        setNotificationMessage(e.toString());
        setShowNotification(true);

        setSelectedType('');
      },
    }))
  }

  // -- react hooks --//
  useEffect(() => {
    fetchList();
  }, []);

  useEffect(() => {
    getUserPageAuth(user).then((res) => setReadOnly(res));
  }, [user]);

  useEffect(() => {
    if (tBodyTotal !== null && tBodyTotal !== undefined) {
      setTbodyTotal(tBodyTotal);
    } else {
      setTbodyTotal([]);
    }
  }, [tBodyTotal]);

  useEffect(() => {
    if (tBodySelectable !== null && tBodySelectable !== undefined) {
      setTbodySelectable(tBodySelectable);
    } else {
      setTbodySelectable([]);
    }
  }, [tBodySelectable]);

  // -- render --//
  return (
    <div className="page">

      <div className="subTitleText addBtn">
        <div className="" style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
          <p>
            {`기간 합계 ${totalList && totalList[totalList?.length - 1]} ~ ${totalList && totalList[0]}`}
          </p>
          <img className='btnIcons refresh' src={btnIcons.refreshIcon} onClick={() => { fetchList(); }} alt='refreshIcon' />
        </div>
        <button
          className="defaultBtn"
          onClick={() => {
            setIsLoadingRequesting(true);

            setSelectedType('total');

            dispatch(settlementListApprovalRequest({
              issuer: '', // ''로 무시
              dryRun: true, // 미리보기
              settlementIds: totalList,
              callback: (data) => {
                console.log(data);
                setOpen(true);
                setRequiredTransaction(data?.requiredTransaction);
                setIsLoadingRequesting(false);
              },
              error: (e) => {
                console.log(e);
                setNotificationMessage(e.toString());
                setShowNotification(true);
                setIsLoadingRequesting(false);

                setSelectedType('');
              },
            }));
          }}
          disabled={readOnly}
        >
          일괄 정산
        </button>
      </div>

      <div className="spaceDiv10"/>

      <table style={{ tableLayout: 'fixed' }}>
        <thead>
        <tr>
          {
            tHeadTotal.map((header, index) => (
              <th key={index} className="">
                {header}
              </th>
            ))
          }
        </tr>
        </thead>
        <tbody>
        {
          isLoadingTotal ? (
            <tr>
              <td
                colSpan={tHeadTotal.length}
                style={{ textAlign: 'center', backgroundColor: '#FAFBFC' }}
              >
                Loading...
              </td>
            </tr>
          ) : totalCount > 0 ? (tokens.map((token, index) => (
            <tr key={index}>
              <td className="">
                {token}
              </td>
              {
                settlementDataKeys.slice(tokens.length)
                  .filter((key) => Object.keys(tBodyTotal ?? [])
                    .includes(key))
                  .map((key) => (
                    <td key={`${token}-${key}`} className="">
                      {
                        tBodyTotal[key][token.toLowerCase()]
                      }
                    </td>
                  ))
              }
            </tr>
          ))) : (
            <tr>
              <td
                colSpan={tHeadTotal.length}
                style={{
                  textAlign: 'center',
                  backgroundColor: '#FAFBFC'
                }}
              >
                등록된 정산 정보가 없습니다.
              </td>
            </tr>
          )
        }
        </tbody>
      </table>

      <div className="spaceDiv10"/>

      <div className="subTitleText addBtn">
        <p>
          {`정산이 필요한 내역 (${totalCount})`}
        </p>
        <button
          className="defaultBtn"
          onClick={() => {
            approvalData();
          }}
          disabled={readOnly}
        >
          선택된 날짜 정산
        </button>
      </div>

      <div className="spaceDiv10"/>

      <table style={{ tableLayout: 'inherit' }}>
        <thead>
        <tr>
        {tHeadSelectable.map((i, index) => (
            <th key={index} className="" style={{ width: index === 0 ? 'inherit' : 'auto' }}>
              {i}
            </th>
          ))}
        </tr>
        </thead>
        <tbody>
        {isLoadingSelectable ? (
          <tr>
            <td
              colSpan={tHeadSelectable.length}
              style={{ textAlign: 'center', backgroundColor: '#FAFBFC' }}
            >
              Loading...
            </td>
          </tr>
        ) : totalCount > 0 ? (tBodySelectable?.map((settlement) => {
          return (
            <React.Fragment key={settlement.settlementId}>
              {tokens.map((token, rowIndex) => (
                <tr key={`${settlement.settlementId}-${token}`}>
                  {rowIndex === 0 && (
                    <React.Fragment>
                      <td
                        className=""
                        rowSpan={tokens.length}
                        onClick={() => handleCheckboxChange(settlement.settlementId)}
                        style={{
                          cursor: 'pointer',
                          width: 'auto',
                          height: 'auto'
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={selectedSettlementIds.includes(settlement.settlementId)}
                          onChange={() => handleCheckboxChange(settlement.settlementId)}
                          style={{
                            left: '30%',
                          }}
                        />
                      </td>
                      <td className="" rowSpan={tokens.length}>
                        {settlement.settlementId}
                      </td>
                      <td className="" rowSpan={tokens.length}>
                        {timeFormAPI.changeDataDate(settlement.date)}
                      </td>
                    </React.Fragment>
                  )}
                  <td className="">
                    {token}
                  </td>
                  {settlementDataKeys.slice(tokens.length + 2).map((key) => (
                    <td key={`${settlement.settlementId}-${key}-${token}`} className="">
                      {settlement.settlements[key][token.toLowerCase()]}
                    </td>
                  ))}
                </tr>
              ))}
            </React.Fragment>
          );
        })) : (
          <tr>
            <td
              colSpan={tHeadSelectable.length}
              style={{
                textAlign: 'center',
                backgroundColor: '#FAFBFC'
              }}
            >
              등록된 정산 정보가 없습니다.
            </td>
          </tr>
        )}
        </tbody>
      </table>

      <div className="spaceDiv10"/>

      <div className="subTitleText addBtn">
        <p>

        </p>
        <button
          className='defaultBtn'
          onClick={() => {
            approvalData();
          }}
          disabled={readOnly}
        >
          선택된 날짜 정산
        </button>
      </div>

      {/* 미리보기 모달 */}
      <Modal
        open={openModal}
        onClose={() => {
          setOpen(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modalBox">
          <div className="modalTitle">
            정산 내역 미리보기
            <img
              src={BtnIcons.closeIcon}
              onClick={() => {
                setOpen(false);
              }}
              style={{
                cursor: 'pointer',
                float: 'right'
              }}
              alt="closeIcon"
            />
          </div>

          <div className="sectionLine"/>

          <div className="descText flex long">

            <table style={{ tableLayout: 'inherit' }}>
              <thead>
              <tr>
                <th></th>
                {tokens.map((i, index) => (
                  <th key={index} className="">
                    {i}
                  </th>
                ))}
              </tr>
              </thead>
              <tbody>
              {modalItems?.map((item, rowIndex) => (
                <tr key={rowIndex}>
                  <td>
                    <span
                      style={{
                        color: item.key === 'minimumRequirementToTransfer' && isMinimumRequirementNotMet
                          ? '#E90A32'
                          : item.key === 'nonTransferable' || item.key === 'available'
                            ? '#787878'
                            : '#141414'
                      }}
                    >
                      {item.label}
                    </span>
                  </td>
                  {tokens.map((token, colIndex) => (
                    <td key={`${rowIndex}-${colIndex}`}>
                      <span
                        style={{
                          color: item.key === 'minimumRequirementToTransfer' && isMinimumRequirementNotMet
                            ? '#E90A32'
                            : item.key === 'nonTransferable' || item.key === 'available'
                              ? '#787878'
                              : '#141414'
                        }}
                      >
                        {
                          item.key === 'fee'
                            ? (selectedType === 'total'
                                ? tBodyTotal?.MarketFee?.[token.toLowerCase()] +
                                      tBodyTotal?.MarketRoyaltyFee?.[token.toLowerCase()] +
                                      tBodyTotal?.TransactionFee?.[token.toLowerCase()] +
                                      tBodyTotal?.NftTransactionFee?.[token.toLowerCase()] +
                                      tBodyTotal?.ProductFee?.[token.toLowerCase()]
                                : selectedType === 'selected'
                                  ? tBodySelectable?.reduce((acc, settlement) => {
                                    if (selectedSettlementIds.includes(settlement.settlementId)) {
                                      return acc + settlement?.settlements?.MarketFee?.[token.toLowerCase()] +
                                          settlement?.settlements?.MarketRoyaltyFee?.[token.toLowerCase()] +
                                          settlement?.settlements?.TransactionFee?.[token.toLowerCase()] +
                                          settlement?.settlements?.NftTransactionFee?.[token.toLowerCase()] +
                                            settlement?.settlements?.ProductFee?.[token.toLowerCase()];
                                    }
                                    return acc;
                                  }, 0)
                                  : 0
                            )
                            : item.key === 'burning'
                              ? (selectedType === 'total'
                                  ? tBodyTotal?.BurningFee?.[token.toLowerCase()]
                                  : selectedType === 'selected'
                                    ? tBodySelectable?.reduce((acc, settlement) => {
                                      if (selectedSettlementIds.includes(settlement.settlementId)) {
                                        return acc + settlement?.settlements?.BurningFee?.[token.toLowerCase()];
                                      }
                                      return acc;
                                    }, 0)
                                    : 0
                              )
                              : requiredTransaction?.[item.key]?.[token.toLowerCase()] ?? '-'
                        }
                      </span>
                    </td>
                  ))}
                </tr>
              ))}
              </tbody>
            </table>

          </div>

          <div className="rightBtn padding">
            <button className="defaultBtn purple" onClick={() => {
              setOpen(false);
            }}>취소
            </button>
            <button
              className="defaultBtn"
              onClick={() => {
                setIsLoadingRequesting(true);

                dispatch(settlementListApprovalRequest({
                  issuer: '', // ''로 무시
                  dryRun: false, // 실제 처리 요청
                  settlementIds: selectedType === 'total' ? totalList : selectedSettlementIds,
                  callback: (data) => {
                    console.log(data);

                    if (data.resultCode === 200) {
                      setIsLoadingRequesting(false);
                      setOpen(false);
                      setOpenApprovaled(true);
                      setRequiredTransaction(data?.requiredTransaction);
                    }

                    // 리스트 갱신
                    fetchList();
                  },
                  error: (e) => {
                    console.log(e);
                    setIsLoadingRequesting(false);
                    setNotificationMessage(e.toString());
                    setShowNotification(true);

                    setSelectedType('');
                  },
                }))
              }}
              disabled={isMinimumRequirementNotMet || isLoadingRequesting}
            >
              정산 요청
            </button>
          </div>

        </Box>
      </Modal>

      {/* 정산 완료 확인 모달 */}
      <Modal
        open={openModalApprovaled}
        onClose={() => {
          setOpenApprovaled(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modalBox">
          <div className="modalTitle">
            정산 완료 내역 확인
            <img
              src={BtnIcons.closeIcon}
              onClick={() => {
                setOpenApprovaled(false);
              }}
              style={{
                cursor: 'pointer',
                float: 'right'
              }}
              alt="close"
            />
          </div>

          <div className="sectionLine"/>

          <div className="descText flex long">

            <table style={{ tableLayout: 'inherit' }}>
              <thead>
              <tr>
                <th>

                </th>
                {tokens.map((i, index) => (
                  <th key={index} className="">
                    {i}
                  </th>
                ))}
              </tr>
              </thead>
              <tbody>
              {
                modalItems
                  .filter((item) => item.key !== 'fee' && item.key !== 'burning')
                  .map((item, rowIndex) => (
                    <tr key={rowIndex}>
                      <td>{item.label}</td>
                      {tokens.map((token, colIndex) => (
                        <td key={`${rowIndex}-${colIndex}`}>
                          {requiredTransaction?.[item.key]?.[token.toLowerCase()] ?? '-'}
                        </td>
                      ))}
                    </tr>
                  ))
              }
              </tbody>
            </table>

          </div>

          <div className="rightBtn padding">
            <button className="defaultBtn" onClick={() => { setOpenApprovaled(false) }}>확인</button>
          </div>

        </Box>
      </Modal>

      {
        showNotification ? (
          <Notification
            close={() => setShowNotification(false)}
            message={notificationMessage}
          />
        ) : null
      }

    </div>
  )
}

export default needSettlement;
